import { IProfileData } from '../../../components/ProfileDetailsForm/ProfileDataForm.types'
import { ISaveUser } from '../../../utils/types'

export const isProfileData = (data: ISaveUser): data is IProfileData => {
    return (data as IProfileData).email !== undefined
}
